import {Component, forwardRef, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {SelectorContainer} from "../../core/definitions/selector-container";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ObjectSearchModule} from "../../object-search/object-search.module";
import {AConst} from "../../core/a-const.enum";
import {Selector} from "../../core/definitions/reference";
import {SearchContainerParams} from "../../core/definitions/search-container";
import {SearchObject} from "../../core/definitions/search-object";
import {SearchHandlerService} from "../../object-search/search-handler.service";

interface SelectorWrapperData {
  selector: Selector;
  selectorContainer: SelectorContainer;
}

@Component({
  selector: 'app-edit-object-dialog-selector-wrapper',
  imports: [
    forwardRef(() => ObjectSearchModule)
  ],
  templateUrl: './edit-object-dialog-selector-wrapper.html',
  styleUrl: './edit-object-dialog-selector-wrapper.scss',
})
export class EditObjectDialogSelectorWrapper implements OnInit {
  public dialogData: SelectorWrapperData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<EditObjectDialogSelectorWrapper> = inject(MatDialogRef);

  private readonly searchHandler: SearchHandlerService = inject(SearchHandlerService);

  selectorContainer: WritableSignal<SelectorContainer> = signal(null);
  showDialog: WritableSignal<boolean> = signal(false);

  ngOnInit() {
    this.initializeSelector();
  }

  initializeSelector() {
    const selectorContainer = this.dialogData.selectorContainer;
    const filters = this.getFilters(this.dialogData.selector.filters, selectorContainer.art);

    if (!Object.keys(filters).length) {
      filters['object_type'] = this.dialogData.selectorContainer.art.object_type;
    }

    const searchContainerParams = new SearchContainerParams();
    searchContainerParams.searchViewName = this.dialogData.selector.view;
    searchContainerParams.filters = filters;
    searchContainerParams.defaultCheckedFilters = this.getFilters(this.dialogData.selector.checked_filters, selectorContainer.art);
    searchContainerParams.runSearch = false;
    searchContainerParams.selectedItems = this.dialogData.selector.selected;
    searchContainerParams.used = this.dialogData.selector.used || [];
    searchContainerParams.restrictions = this.dialogData.selector.restrictions;
    searchContainerParams.keepSelected = true;
    this.searchHandler.createSearchContainer(searchContainerParams).then(
      (sc) => {
        sc.queryContainer.query = this.dialogData.selector.query;
        sc.selections.singleSelect = true;
        sc.selections.selectCallback = (selectedObjects: SearchObject[]) => {
          this.selectCallback(this.dialogData.selector, null, selectedObjects);
        };
        sc.selectButtonText = this.dialogData.selector.select_button_text;1
        //fns.searchContainerCreated(sc);
        /*document.getElementsByTagName('body')[0]
          .classList.add('selector-open');
        document.getElementsByTagName('html')[0]
          .classList.add('selector-open');*/
        selectorContainer.selectorEnabled = true;
        selectorContainer.searchContainer = sc;

        this.selectorContainer.set(selectorContainer);
        this.showDialog.set(true);
        //this._searchSelectorChanged$.next(container);
      }
    );
  }

  private getFilters(filterInfo, art) {
    const res = {};

    if (filterInfo) {
      filterInfo.forEach((filter) => {
        let filterVal;
        const sourceField = filter[AConst.SOURCE_FIELD];
        res[filter.field] = res[filter.field] || [];
        if (sourceField) {
          if (art) {
            filterVal = art[sourceField];
          } else {
            console.warn('Missing artifact for retrieving source field value: ' + sourceField);
          }
        } else if (filter.value) {
          filterVal = filter.value;
        } else {
          throw new Error('Missing filter value!');
        }
        res[filter.field].push(filterVal);
      });
    }
    return res;
  }

  selectCallback(selector: Selector, fns: any, searchObjects: SearchObject[]) {
    this.dialogRef.close(searchObjects);
  }
}
